export enum OrderCategory {
    HISTORY = "history",
    PROCESSING = "processing",
    ALL = "all"
}